<template>
  <v-card
    :wxid="$options.name"
    :class="[{ disabled: isTileDisabled, unfocused: isTileUnfocused }, targetStatusClass]"
    class="tile quality status-pictogram"
    tag="section"
    sf="3"
  >
    <grouped-tile-selector-menu :tile-index="tileIndex" />
    <div class="tile-inner">
      <h3 :title="$t('tiles.quality')" class="primary-title">
        {{ $t("tiles.quality") }}
        <v-icon v-if="!isTileAuthorized()">mdi-lock</v-icon>
      </h3>
      <h2 class="primary-value">{{ primaryValue }}</h2>
      <section v-if="displayTarget" class="status-details">
        <dl>
          <dt>{{ targetType }}</dt>
          <dd class="d-flex align-center">
            <v-icon class="mr-1">mdi-target</v-icon>
            {{ targetValue }}
          </dd>
        </dl>
        <div class="pictogram" />
      </section>
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import GroupedTileSelectorMenu from "@/components/dashboard/tiles/GroupedTileSelectorMenu";
import TileBase from "@/components/dashboard/tiles/TileBase";
import Tiles from "@/components/Tiles";
import Helpers from "@/helpers";
import PackageFeatures from "@/components/PackageFeatures";

export default {
  name: "TileQuality",
  extends: TileBase,
  inheritAttrs: false,
  components: { GroupedTileSelectorMenu },
  computed: {
    ...mapGetters("dashboard", ["quality", "qualityTarget"]),
    ...mapGetters("packages", ["activePuHasRequiredFeature"]),
    ...mapGetters("tiles", ["selectedTileIndex"]),
    isTileUnfocused() {
      return this.selectedTileIndex !== null && this.tileIndex !== this.selectedTileIndex;
    },
    isTileDisabled() {
      return !this.isTileAuthorized();
    },
    // Quality
    displayTarget() {
      // Reject module is necessary to show the calculated Quality value and its target.
      // If the module is not there, the configured Quality is used, without a target.
      return this.activePuHasRequiredFeature(PackageFeatures.reject);
    },
    primaryValue() {
      if (this.quality == null) return "—";
      return this.isTileAuthorized() ? Helpers.round(this.quality, 1) + "%" : "—";
    },
    targetValue() {
      if (this.qualityTarget) {
        return Helpers.round(this.qualityTarget, 1) + "%";
      } else {
        return this.$t("common.nA");
      }
    },
    targetType() {
      return this.$t("dashboard.targetInfo.line");
    },
    targetStatusClass() {
      if (!this.displayTarget) return this.defaultStateCssClass;

      let statusClass;
      if (this.qualityTarget && this.quality) {
        const value = this.quality - this.qualityTarget;
        if (value >= 0) {
          statusClass = this.successCssClass;
        } else if (value >= -5) {
          statusClass = this.warningCssClass;
        } else {
          statusClass = this.errorCssClass;
        }
      }
      return statusClass;
    },
  },
  methods: {
    isTileAuthorized() {
      return this.activePuHasRequiredFeature(Tiles.quality.requiredFeature);
    },
  },
};
</script>
